// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import { Item2ProductModuleData } from '@reverbdotcom/commons/src/gql/graphql';
import { RCAccordion } from '@reverbdotcom/cadence/components';
import { Item2ReportMismatchedProduct } from './item2_report_mismatched_product';
import { Item2ProductModuleHeader } from './item2_product_module_header';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

interface IProps {
  listing: Item2ProductModuleData.Fragment;
}

const COMPONENT_NAME = 'Item2ProductModule';

export const Item2ProductModuleFragment = gql`
fragment Item2ProductModuleData on Listing {
  _id
  id
  canonicalProductId
  condition {
    conditionSlug
  }
  categories {
    _id
    id
    slug
    name
    rootSlug
    webLink {
      href
    }
    cmsLink {
      href
    }
    parentCategories {
      _id
      slug
    }
  }
  csp {
    _id
    id
    title
    slug
    webLink {
      path
    }
    image(input: {transform: "card_square"}) {
      _id
      source
    }
    inventory {
      newLowPrice {
        display
        amountCents
      }
      usedLowPrice {
        display
        amountCents
      }
      usedTotal
      newTotal
    }
    specs {
      productSpecs {
        _id
        type
        name
        value
        path
      }
    }
  }
}
`;

export function componentClickEvent(displayStyle, path) {
  return {
    eventName: MParticleEventName.ClickedComponent,
    componentName: COMPONENT_NAME,
    displayStyle,
    entityType: 'url',
    entityId: path,
  };
}

export function Item2ProductModule(props: IProps) {
  const { csp, categories, canonicalProductId, condition } = props.listing;
  if (!csp) return null;

  return (
    <RCAccordion
      heading={I18n.t('discovery.item2ProductModule.productOverview')}
      id="product-overview"
      defaultOpen
      size="large"
    >
      <div className="item2-product-module">
        <Item2ProductModuleHeader
          canonicalProductId={canonicalProductId}
          csp={csp}
          categories={categories}
          componentName={COMPONENT_NAME}
          listingCondition={condition.conditionSlug}
        />
        <div className="item2-product-module__mismatch">
          <Item2ReportMismatchedProduct listingId={props.listing.id} />
        </div>
      </div>
    </RCAccordion>
  );
}
